import React from 'react'
import constants from '../constants'
import Grid from './grid'

const BlockSection = ({
  sectionClassName,
  anchorName,
  backgroundClassName,
  titleClassName,
  titleContent,
  subtitleContent,
  svgWrapperClassName,
  date,
  isAnnées = false,
  annéesClassName,
  children
}) => {
  const subtitleHasNumbers = /\d/.test(subtitleContent)
  return (
    <section data-anchor={anchorName} className={`section block-section ${sectionClassName}`}>
      <a name={anchorName} className={`anchor-item tw-relative tw--top-20 tw-block md:tw--top-12`} />
      <div className={`tw-relative`}>
        <div className={`tw-relative tw-z-10`}>
          <Grid className={`tw-relative`}>
            <div className={`tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 xl:tw-col-end-11 2xl:tw-col-start-4 2xl:tw-col-end-9`}>
              {titleContent &&
              <h2 className={`${titleClassName} ${constants.h1} tw-relative tw-uppercase tw-z-50 section-title-h2`}>
                <div className={`tw-py-1 tw-relative`}>
                  <span className={`tw-absolute tw--top-2 md:tw--top-5 tw-left-0 md:tw--left-10 lg:tw--left-12 2xl:tw--left-16 tw-bg-gold tw-block tw-h-px tw-w-10 lg:tw-w-12 2xl:tw-w-16`} />
                  <div className={`${subtitleHasNumbers ? '' : 'direction-assign'} tw-absolute tw--top-4 md:tw--top-7 tw-left-14 md:tw-left-2 tw-text-gray-600 tw-text-tiny`}>{subtitleContent}</div>
                </div>
                <div style={{ letterSpacing: LANG_ID === 'ar' ? 0 : 'auto' }} className="direction-assign">{titleContent}</div>
              </h2>
              }
              { date &&
              <div style={{ transform: `translateZ(20px)` }} className={`${svgWrapperClassName} tw-relative tw-z-20 tw-font-sans`}>
                <div className={`block-date tw-whitespace-nowrap tw-flex md:tw-justify-center`} style={{ fontSize: `22.2vw`, lineHeight: `16vw`, color: `transparent`, WebkitTextStroke: `1px`,  WebkitTextStrokeColor: `#B59860` }}>
                  {date}
                </div>
              </div>
              }
              {isAnnées &&
              <div className={`${annéesClassName} section-years`}>
                <div className={`tw-uppercase tw-font-sans tw-text-gold tw-text-sm sm:tw-text-2xl md:tw-text-3xl xl:tw-text-4xl 2xl:tw-text-5xl direction-assign`}>{constants.UI.years}</div>
              </div>}
            </div>
          </Grid>
          <Grid className={`tw-max-w-screen-2xl tw-mx-auto`}>
            {children}
          </Grid>
        </div>
        <div className={`${backgroundClassName} tw-absolute tw-w-full tw-top-0 tw-left-0 tw-z-0`} />
      </div>
    </section>
  )
}

export default BlockSection


